import moment from "moment"
import { SUBSCRIPTION_STATUS } from "./constants"

export const ACCESS_STATE = {
  SUBSCRIBED: "subscribed",
  TRIAL: "trial",
  READ_ONLY: "read_only",
  LOCKED: "locked",
  PAYMENT_PROBLEM: "payment_problem",
  DISABLED: "disabled",
}

const LIVE = [SUBSCRIPTION_STATUS.ACTIVE, SUBSCRIPTION_STATUS.TRIALING]

// Access state computed by the backend. If an older backend does not send it, fall back to the
// previous dashboard rule (anything not ACTIVE/TRIALING is a paywall) so nothing changes for those.
export function getAccessState(businessAccount) {
  if (!businessAccount) return null
  if (businessAccount.accessState) return businessAccount.accessState
  const details = businessAccount.subscriptionDetails
  if (!details || details.subscriptionsEnabled !== true) return ACCESS_STATE.DISABLED
  if (LIVE.includes(details.stripeSubscriptionStatus)) return ACCESS_STATE.SUBSCRIBED
  if (details.stripeSubscriptionStatus && details.stripeSubscriptionStatus !== SUBSCRIPTION_STATUS.CANCELLED) {
    return ACCESS_STATE.PAYMENT_PROBLEM
  }
  return ACCESS_STATE.LOCKED
}

export const formatTrialDate = (value) => (value ? moment(value).format("D MMMM YYYY") : "")

export const getOnboardingUrl = () => (process.env.REACT_APP_ONBOARDING_URL || "").trim()
